import propTypes from 'prop-types';
import React, {Component} from 'react';
import {connect} from 'react-redux';
import _ from 'lodash';
import {checkFileName} from 'MyAccount/AssetManager/ImageManager/helpers';
import {getCurrentFolderImages, getUploadedFiles} from 'MyAccount/AssetManager/ImageManager/selectors';
import {
  pushImageToBar,
  changeFileStatusError,
  changeFileStatusSuccess,
  retryUploadFileInBar,
} from 'MyAccount/ViewDesigns/redux/modules/images';
import UploadImageButton from 'shared/components/UploadImageButton';
import {getFormData} from 'shared/helpers/ImageUploadHelpers';
import {
  ERROR_FILE_UPLOAD_STATUS,
  CANCELED_FILE_UPLOAD_STATUS,
  UPLOADED_FILE_UPLOAD_STATUS,
  LOADING_FILE_UPLOAD_STATUS,
} from 'MyAccount/AssetManager/ImageManager/consts';
import $ from 'jquery';
import {isEbayImage} from 'MyAccount/ViewDesigns/helpers/resizeImageUrlHelper';
const ABORT_STATUS_TEXT = 'abort';
const GENERAL_ERROR_MESSAGE = "Something went wrong, that's really all we know";

@connect(
  (state, props) => ({
    // TODO currentImages: getCurrentFolderImages(state, props),
    // uploadedFiles: getUploadedFiles(state, props),
  }),
  {pushImageToBar, changeFileStatusSuccess, changeFileStatusError, retryUploadFileInBar}
)
export default class UploadImageToEbayButton extends Component {
  static contextTypes = {
    imageUtils: propTypes.object.isRequired,
  };

  onFileUpload({imageName, url}) {
    const {onFileUpload, changeFileStatusSuccess, changeFileStatusError} = this.props;
    onFileUpload({imageName, url}, response => {
      const {success, name, resourceType, error} = response;
      if (success) {
        changeFileStatusSuccess({name, resourceType});
      } else {
        changeFileStatusError({name, resourceType, error, status: ERROR_FILE_UPLOAD_STATUS});
      }
    });
  }

  uploadImages = files => {
    const {site, reUploadNonEbayImages} = this.props;
    // TODO check if both contentType and processData are needed
    const imagesToUpload = _.map(files, file => {
      const formData = getFormData(file);
      formData.append('name', file.name);
      formData.append('site', site);
      const ajaxParams = {
        contentType: false,
        processData: false,
        data: formData,
      };
      return {ajaxParams, imageName: file.name, thumbnailUrl: file.url};
    });
    this.uploadImagesToEbayPictureService(imagesToUpload, reUploadNonEbayImages);
  };

  handleReUploadNonEbayImages = () => {
    const {onChange, ebayGalleryUrls} = this.props;
    const ebayImages = _.concat([], ebayGalleryUrls);
    const imagesToUpload = [];
    _.forEach(ebayGalleryUrls, (url, index) => {
      if (url && !isEbayImage(url)) {
        _.pull(ebayImages, url);
        imagesToUpload.push({id: index, name: 'Product Photo ' + index, src: url, valid: true});
      }
    });
    onChange(ebayImages);
    this.uploadImagesFromUrl(imagesToUpload, false);
  };

  uploadImagesToEbayPictureService = (imagesToUpload, reUploadNonEbayImages) => {
    const {pushImageToBar, changeFileStatusError} = this.props;
    if (reUploadNonEbayImages) {
      this.handleReUploadNonEbayImages();
    }
    _.forEach(imagesToUpload, ({ajaxParams, imageName, thumbnailUrl}) => {
      let toUpload = {name: imageName, url: thumbnailUrl, resourceType: 'DescriptionImages'};
      const cancelUpload = this.callUploadImageAjax(imageName, ajaxParams);
      toUpload = {
        ...toUpload,
        status: LOADING_FILE_UPLOAD_STATUS,
        cancelUpload: () => {
          cancelUpload();
          changeFileStatusError({
            name: imageName,
            resourceType: 'DescriptionImages',
            status: CANCELED_FILE_UPLOAD_STATUS,
          });
        },
        retryUpload: () => this.retryImageUpload(imageName, ajaxParams),
      };
      pushImageToBar(toUpload);
    });
  };

  retryImageUpload = (imageName, ajaxParams) => {
    const {retryUploadFileInBar, changeFileStatusError} = this.props;
    const cancelUpload = this.callUploadImageAjax(imageName, ajaxParams);
    retryUploadFileInBar({
      name: imageName,
      resourceType: 'DescriptionImages',
      cancelUpload: () => {
        cancelUpload();
        changeFileStatusError({
          name: imageName,
          resourceType: 'DescriptionImages',
          status: CANCELED_FILE_UPLOAD_STATUS,
        });
      },
    });
  };

  checkFileName = filename => {
    const {currentImages, uploadedFiles} = this.props;
    // check in upload images
    let fileNameChecked = checkFileName(currentImages, filename);
    // check in error upload in status bar
    fileNameChecked = checkFileName(uploadedFiles, fileNameChecked);
    return fileNameChecked;
  };

  uploadImagesFromUrl = (urls, reUploadNonEbayImages) => {
    const {site} = this.props;
    const imagesToUpload = _.map(urls, url => {
      return {
        ajaxParams: {
          data: {
            fileExternalURL: url.src,
            name: url.name,
            site,
          },
        },
        imageName: url.name,
        thumbnailUrl: url.src,
      };
    });
    this.uploadImagesToEbayPictureService(imagesToUpload, reUploadNonEbayImages);
  };

  callUploadImageAjax = (imageName, ajaxParams) => {
    const {changeFileStatusError} = this.props;
    let cancelUpload = null;
    $.ajax({
      method: 'POST',
      url: '/ebay/ebay/upload-image-to-ebay-picture-service',
      ...ajaxParams,
      beforeSend: jqXHR => {
        cancelUpload = jqXHR.abort;
      },
    })
      .then(response => {
        if (response.success) {
          this.onFileUpload({imageName, ...response});
        } else {
          const error = response.errorMessage ? response.errorMessage : GENERAL_ERROR_MESSAGE;
          changeFileStatusError(imageName, {status: ERROR_FILE_UPLOAD_STATUS, error});
        }
      })
      .fail(response => {
        if (response.statusText === ABORT_STATUS_TEXT) {
          changeFileStatusError(imageName, {status: CANCELED_FILE_UPLOAD_STATUS});
        } else {
          console.warn('PhotosSection - upload failed - response: ', response);
          changeFileStatusError(imageName, {status: ERROR_FILE_UPLOAD_STATUS, error: GENERAL_ERROR_MESSAGE});
        }
      });
    return cancelUpload;
  };

  render() {
    const {buttonLabel, uniqueIdForUploadDialog, reUploadNonEbayImages, id} = this.props;
    return (
      <UploadImageButton
        id={id}
        uploadImages={this.uploadImages}
        uploadImagesFromUrl={urls => this.uploadImagesFromUrl(urls, reUploadNonEbayImages)}
        buttonLabel={buttonLabel}
        uniqueIdForUploadDialog={uniqueIdForUploadDialog}
      />
    );
  }
}

UploadImageToEbayButton.propTypes = {
  onFileUpload: propTypes.func.isRequired,
  site: propTypes.string.isRequired, // added this cuz I didnt want to convert to Typescript and it bothered me, dont copy, use TS!
};
